module.exports = __webpack_public_path__ + "img/3ddd5d0.png";